<div class="banner_header">
    <div class="col-md-12">
        <h2 style="margin-bottom: 0px;">Track Your Status</h2>
    </div>
</div>

<div class="container download_section pad_btm_size">


    <div class="row" *ngIf="bool_trackCompEnter">


        <div class="col-md-8 instruc_left">
            <div style="padding: 0px 15px;">
                <h2>Instructions</h2>
                <p> 1. This CBT Grievance readdressal system is for raising your grievance related to CBT Exam and Fee
                    payments.
                </p>
                <p> 2. For Grievance related to CBT Exam, a grievance can be raised only by the Invigilator using his
                    CBT
                    Attendance App login. </p>
                <p> 3. An Invigilator can raise a grievance for the candidates mapped to his centre alone. </p>
                <p> 4. Kindly check the displayed data of the candidate before raising the grievance </p>
                <p> 5. A grievance for a candidate can be raised only once. </p>
                <p> 6. A grievance Ticket ID will be generated for each grievance raised and the status can be tracked
                    in the
                    invigilator login. </p>
                <p> 7. All tickets raised details will be available in the Invigilator login. </p>
            </div>
        </div>

        <div class="col-md-4 instruc_right">

            <!--Raise complaint Login Start-->
            <div>
                <div class="card-body" style="padding: 0px;">



                    <form [formGroup]="trackIdForm" (ngSubmit)="onSubmitTrackId()">
                        <div class="form-row">
                            <div class="form-group col-12">
                                <label>Enter Your Ticket IDs</label>
                                <input type="text" formControlName="ticketId" class="form-control"
                                    [ngClass]="{ 'is-invalid': submitted && t.ticketId.errors }"
                                    (keypress)="omit_spl($event)" maxlength="15" />
                                <div *ngIf="submitted && t.ticketId.errors" class="invalid-feedback">
                                    <div *ngIf="t.ticketId.errors.required">TicketID is required</div>
                                </div>
                            </div>

                            <div class="form-group col-12">
                                <div class="text-center">
                                    <button class="btn btn-primary mr-1">View
                                        Status</button>
                                    <!-- <button type="button" (click)="onLoginReset()" class="btn btn-primary mr-1">Login</button> -->
                                </div>
                            </div>


                        </div>
                    </form>
                </div>
            </div>
            <!--Raise complaint Login End-->

        </div>


    </div>


    <div *ngIf="bool_trackComp">
        <div class="card m-3">
            <h5 class="card-header" style="font-size: 21px; background-color: red;" [ngStyle]="styleObject">
                Your Complaint Status {{this.pdu_admin_status}}
            </h5>
            <div class="card-body" style="padding-top: 0px;">
                <div class="row">
                    <div style="text-align: right; width: 100%;">
                        <button (click)="back_fn()" class="btn btn-primary mr-1">Back</button>

                    </div>
                    <div *ngIf="status_list_bool_pdu" class="col-md-12 status_tag" style="text-align: left;">

                        <table class="status_table">
                            <tr>
                                <th>Ticket Id</th>
                                <td>{{this.pdu_ticketId}} </td>
                            </tr>
                            <tr>
                                <th> Grievance date</th>
                                <td> {{this.pdu_entrydate}} </td>
                            </tr>
                            <tr>
                                <th>State</th>
                                <td>{{this.pdu_state}} </td>
                            </tr>
                            <tr>
                                <th>District</th>
                                <td>{{this.pdu_district}} </td>
                            </tr>
                            <tr>
                                <th>ITI Code</th>
                                <td>{{this.pdu_iticode}} </td>
                            </tr>

                            <tr>
                                <th>Name</th>
                                <td>{{this.pdu_name}} </td>
                            </tr>
                            <tr>
                                <th>Email</th>
                                <td>{{this.pdu_email}} </td>
                            </tr>
                            <tr>
                                <th>Mobile Number</th>
                                <td>{{this.pdu_mobileno}} </td>
                            </tr>
                            <tr>
                                <th>CC Ref Number</th>
                                <td>{{this.pdu_ccrefno}} </td>
                            </tr>
                            <tr>
                                <th>CC Ref Number Status</th>
                                <td>{{this.pdu_ccrefnostatus}} </td>
                            </tr>
                            <tr>
                                <th>Order Id</th>
                                <td>{{this.pdu_orderid}} </td>
                            </tr>
                            <tr>
                                <th>Payment Date</th>
                                <td>{{this.pdu_date}} </td>
                            </tr>

                            <tr>
                                <th>Single Register Number</th>
                                <td>{{this.pdu_singlerollno}} </td>
                            </tr>

                            <tr>
                                <th> Bulk Register Number</th>
                                <td>
                                    <div *ngFor="let a of bulkregno let i=index">
                                        <p>{{a.regno}}</p>
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <th>Number Of Student</th>
                                <td>{{this.pdu_numberofstud}} </td>
                            </tr>
                            <tr>
                                <th>Amount</th>
                                <td>{{this.pdu_amount}} </td>
                            </tr>
                            <tr>
                                <th>Additional Description</th>
                                <td>{{this.pdu_descreption}} </td>
                            </tr>

                            <tr>
                                <th>Grievance Status</th>
                                <td>{{this.pdu_admin_status}} </td>
                            </tr>
                            <tr>
                                <th>Grievance Status Description</th>
                                <td>{{this.pdu_admin_status_desc}} </td>
                            </tr>
                        </table>

                    </div>

                    <hr>

                    <div *ngIf="status_list_bool_eri" class="col-md-12 status_tag" style="text-align: left;">

                        <table class="status_table">
                            <tr>
                                <th>Ticket Id</th>
                                <td>{{this.erform_ticketId}} </td>
                            </tr>
                            <tr>
                                <th>Email</th>
                                <td>{{this.erform_email}} </td>
                            </tr>
                            <tr>
                                <th>State</th>
                                <td>{{this.erform_state}} </td>
                            </tr>
                            <tr>
                                <th>District</th>
                                <td>{{this.erform_district}} </td>
                            </tr>
                            <tr>
                                <th>ITI Code</th>
                                <td>{{this.erform_iticode}} </td>
                            </tr>
                            <tr>
                                <th>Trade</th>
                                <td>{{this.erform_trade}} </td>
                            </tr>
                            <tr>
                                <th>Register Number</th>
                                <td>{{this.erform_regno}} </td>
                            </tr>
                            <tr>
                                <th>Name</th>
                                <td>{{this.erform_name}} </td>
                            </tr>
                            <tr>
                                <th>Date</th>
                                <td>{{this.erform_date}} </td>
                            </tr>
                            <tr>

                            <tr>
                                <th>Shift</th>
                                <td>{{this.erform_shift}} </td>
                            </tr>
                            <tr>
                                <th>Attendance</th>
                                <td>{{this.erform_attendance}} </td>
                            </tr>
                            <tr>
                                <th>Status</th>
                                <td>{{this.erform_status}} </td>
                            </tr>
                            <tr>
                                <th>Center</th>
                                <td>{{this.erform_center}} </td>
                            </tr>

                            <tr>
                                <th>NTEF</th>
                                <td>{{this.erform_ntef}} </td>
                            </tr>




                            <tr>
                                <th>Issue Detail</th>
                                <td>{{this.erform_issuedetail}} </td>
                            </tr>

                            <tr>
                                <th>Description of the other issue</th>
                                <td>{{this.erform_description}} </td>
                            </tr>
                            <tr>
                                <th>Admin Status</th>
                                <td>{{this.erform_admin_status}} </td>
                            </tr>
                            <tr>
                                <th>Admin Status Description </th>
                                <td>{{this.erform_admin_status_desc}} </td>
                            </tr>
                        </table>




                    </div>

                    <div *ngIf="status_list_bool_cri" class="col-md-12 status_tag" style="text-align: left;">

                        <table class="status_table">
                            <tr>
                                <th>Ticket Id</th>
                                <td>{{this.criform_ticketId}} </td>
                            </tr>
                            <tr>
                                <th>Email</th>
                                <td>{{this.criform_email}} </td>
                            </tr>
                            <tr>
                                <th>State</th>
                                <td>{{this.criform_state}} </td>
                            </tr>
                            <tr>
                                <th>District</th>
                                <td>{{this.criform_district}} </td>
                            </tr>
                            <tr>
                                <th>ITI Code</th>
                                <td>{{this.criform_iticode}} </td>
                            </tr>
                            <tr>
                                <th>Trade</th>
                                <td>{{this.criform_trade}} </td>
                            </tr>
                            <tr>
                                <th>Register Number</th>
                                <td>{{this.criform_regno}} </td>
                            </tr>
                            <tr>
                                <th>Name</th>
                                <td>{{this.criform_name}} </td>
                            </tr>
                            <tr>
                                <th>Date</th>
                                <td>{{this.criform_date}} </td>
                            </tr>
                            <tr>

                            <tr>
                                <th>Shift</th>
                                <td>{{this.criform_shift}} </td>
                            </tr>
                            <tr>
                                <th>Attendance</th>
                                <td>{{this.criform_attendance}} </td>
                            </tr>
                            <tr>
                                <th>Status</th>
                                <td>{{this.criform_status}} </td>
                            </tr>
                            <tr>
                                <th>Center</th>
                                <td>{{this.criform_center}} </td>
                            </tr>

                            <tr>
                                <th>NTEF</th>
                                <td>{{this.criform_ntef}} </td>
                            </tr>

                            <tr>
                                <th>Invigilator Name</th>
                                <td>{{this.criform_invigname}} </td>
                            </tr>


                            <tr>
                                <th>Issue Detail</th>
                                <td>{{this.criform_issuedetail}} </td>
                            </tr>

                            <tr>
                                <th>Description of the other issue</th>
                                <td>{{this.criform_description}} </td>
                            </tr>
                            <tr>
                                <th>Admin Status</th>
                                <td>{{this.criform_admin_status}} </td>
                            </tr>
                            <tr>
                                <th>Admin Status Description </th>
                                <td>{{this.criform_admin_status_desc}} </td>
                            </tr>
                        </table>




                    </div>

                    <div *ngIf="status_list_bool_dnf" class="col-md-12 status_tag" style="text-align: left;">

                      <table class="status_table">
                        <tr>
                            <th>Ticket Id</th>
                            <td> {{this.dnfticketId}} </td>
                        </tr>
                        <tr>
                            <th> Grievance date</th>
                            <td> {{this.dnfentrydate}} </td>
                        </tr>
                        <tr>
                            <th>State</th>
                            <td>{{this.dnfstate}} </td>
                        </tr>


                        <tr>
                            <th>Name</th>
                            <td>{{this.dnfname}} </td>
                        </tr>
                        <tr>
                            <th>Email</th>
                            <td>{{this.dnfemail}} </td>
                        </tr>
                        <tr>
                            <th>Mobile No</th>
                            <td>{{this.dnfmobileno}} </td>
                        </tr>

                        <tr>
                            <th>Payment Date</th>
                            <td>{{this.dnfdate}} </td>
                        </tr>



                        <tr>
                            <th>Bulk Register Number</th>
                            <td>
                                {{this.dnfbulkregno}}
                            </td>
                        </tr>

                        <tr>
                          <th>Payment Method</th>
                          <td>
                              {{this.dnfpaymethod}}
                          </td>
                      </tr>
                      <tr>
                        <th>UTR / Transcation Number</th>
                        <td>
                            {{this.dnfutr}}
                        </td>
                    </tr>
                    <tr>
                      <th>Associated Mobile Number</th>
                      <td>
                          {{this.dnfascmob}}
                      </td>
                  </tr>
                  <tr>
                    <th>Scan Copy Of Chellan</th>
                    <td>
                      <!-- <img class="upload_cls" src="http://localhost:5001/{{this.dnfupload}}"> -->
                      <img class="upload_cls" src="https://grsnodetest.nimiquestionbank.in/{{this.dnfupload}}">
                    </td>
                </tr>


                        <!-- <tr>
                    <th>trade</th>
                    <td>{{this.dnftrade}} </td>
                </tr> -->


                        <tr>
                            <th>Number Of Student</th>
                            <td>{{this.dnfnumberofstud}} </td>
                        </tr>
                        <tr>
                            <th>Amount</th>
                            <td>{{this.dnfamount}} </td>
                        </tr>
                        <tr>
                            <th>Additional Description</th>
                            <td>{{this.dnfdescreption}} </td>
                        </tr>


                        <tr>
                            <th>Admin Status</th>
                            <td>{{this.dnfadmin_status}} </td>
                        </tr>
                        <tr>
                            <th>Admin Status Description</th>
                            <td>{{this.dnfadmin_status_desc}} </td>
                        </tr>



                    </table>

                  </div>
                </div>


            </div>
        </div>
    </div>

</div>


<style>
    .banner_header {
        background: #2955a9;
        padding: 10px 0px;
        text-align: left;
        color: #fff;
        margin: 0px;
    }

    .banner_header h2 {
        font-size: 21px;
    }
</style>
